import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EndPointApi } from '@helpers/endpointapi';
import { RunningHourGroup } from 'icreate/common/models/running-hour-group';
import { lastValueFrom } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class RunningHourService {
    private domain: string;
    private headers: any = new HttpHeaders({
        'Content-Type': 'application/json',
    });

    constructor(private http: HttpClient) {
        this.domain = EndPointApi.iApiDomain();
    }

    async getAllGroups(vesselId: string) {
        return await lastValueFrom(
            this.http.get<RunningHourGroup[]>(`${this.domain}/api/runningHourGroups`, {
                headers: this.headers,
                params: { vesselId },
            })
        );
    }

    async saveAll(runningHourGroupList: RunningHourGroup[]) {
        try {
            return await lastValueFrom(
                this.http.put(`${this.domain}/api/runningHourGroups`, runningHourGroupList, {
                    headers: this.headers,
                })
            );
        } catch (error) {
            throw error;
        }
    }
}
